import THead from './thead';

export default THead;